<!------------------------------

      Page Actions

------------------------------->

@if (!isInIntegratedContext) {
  <ng-container *sbPageAction>
    <button
      *ngPermissions="permissionService.Permission.area_category_create"
      type="button"
      sb-button-primary
      [color]="'green'"
      [icon]="'plus'"
      [loading]="loading()"
      [iconButton]="true"
      (click)="addAreaCategory()"
      sbTooltip="{{ 'lang.areaCategories.createCategory' | translate }}"
    >
    </button>

    <button
      type="button"
      sb-button-primary
      color="blue"
      sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
      container="body"
      [iconButton]="true"
      [icon]="'refresh'"
      (click)="requestDebounced()"
      [disabled]="loading()"
      [loading]="loading()">
    </button>

  </ng-container>
}

<!------------------------------

  side panel / Edit/Create

-------------------------------->

<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="400">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    @if (selectedAreaCategory.id) {
      <h4 [innerHTML]="selectedAreaCategory?.name | truncate : 30"></h4>
    } @else {
      <h4>{{ 'lang.globals.newFile' | translate }}</h4>

    }
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-area-category-edit [category]="selectedAreaCategory"
                              (saveClick)="updateAreaCategory(selectedAreaCategory)"></sb-page-area-category-edit>
</ng-template>


<!------------------------------

    Table Wrapper

------------------------------->
<sb-table-wrapper-new
  headline="{{'lang.headlines.areaCategories' | translate}}"
  [itemsData]="areaCategories"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'areaCategories'">

  <!------------------------------

      Filter Panel

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>

  <!------------------------------

       Table Header

 ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        #
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.parent' | translate }}
      </th>
      <th>
        {{ 'lang.globals.company' | translate }}
      </th>
      <th>
        {{ 'lang.areaCategories.areas' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-category>
    <tr>
      <td>
        {{ category?.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <span firstLine class="cursor-pointer" (click)="!isInModalContext? editAreaCategory(category): ''"
                [innerHtml]="category?.name|truncate:30"></span>
        </sb-comp-name-wrapper>
      </td>
      <td>
        {{ category?.parent?.name }}
      </td>
      <td>
        {{ category?.company?.name }}
      </td>
      <td>
        {{ category?.countAreas }}
      </td>
      <td>
        <sb-comp-display-modified [data]="category"></sb-comp-display-modified>
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext && !isInIntegratedContext) {
          @if (!category.global) {
            <sb-split-button
              [splitButtonItems]="category.sbButtons ?? []"
              (selectedAction)="resolveSplitButtonAction(category, $event)"
            ></sb-split-button>
          }
        } @else {
          @if (isInIntegratedContext) {
            <button sb-button-secondary
                    type="button"
                    ngbTooltip="{{'lang.globals.select' | translate}}"
                    [icon]="'boxChecked'"
                    (click)="selectCategory.emit(category)"
                    [color]="'blue'"
                    [iconButton]="true">
            </button>
          }
        }
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->

  <!-- no Card Element -->

</sb-table-wrapper-new>
